export default __webpack_public_path__ + "static/brand-8-2057b5dd3733160c3643d17a18403bab.png";